module.exports = __webpack_public_path__ + "175df33b2bddd81aae26b82675e6bc82.svg";